var _defs, _title, _polygon, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _title2, _polygon2, _text, _text2, _text3, _text4, _text5, _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "562pt",
    height: "470pt",
    viewBox: "0 0 562.44 470.42",
    id: "svg50",
    xmlSpace: "preserve",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "graph0",
    className: "graph",
    transform: "translate(4,466.4151)"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "title1"
  }, "%3")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    stroke: "transparent",
    points: "-4,4 -4,-466.4151 558.4395,-466.4151 558.4395,4 ",
    id: "polygon1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edge1",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title2"
  }, "00:0c:29:43:d6:e9-&gt;00:0c:29:60:4d:60"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4d00b1",
    strokeWidth: 4.2,
    d: "m 310.8284,-406.5116 c -20.7094,0.4296 -43.5029,0.4597 -64.5043,0.0903",
    id: "path2"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4d00b1",
    stroke: "#4d00b1",
    strokeWidth: 4.2,
    points: "246.3442,-408.2587 246.2734,-404.5844 241.3097,-406.5179 ",
    id: "polygon2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "edge2",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title3"
  }, "00:0c:29:43:d6:e9-&gt;00:0c:29:81:77:9b"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4d00b1",
    strokeWidth: 3.8,
    d: "m 314.0868,-368.3655 c -50.165,30.5408 -119.2587,70.4554 -171.3086,98.9749",
    id: "path3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4d00b1",
    stroke: "#4d00b1",
    strokeWidth: 3.8,
    points: "141.6607,-270.7742 143.3397,-267.7031 138.113,-266.8401 ",
    id: "polygon3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "edge3",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title4"
  }, "00:0c:29:43:d6:e9-&gt;00:0c:29:a0:9b:6b"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1c00e2",
    strokeWidth: 3.3,
    d: "m 412.5543,-368.3152 c 15.2392,24.5759 32.9854,55.243 46.9613,81.1292",
    id: "path4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1c00e2",
    stroke: "#1c00e2",
    strokeWidth: 3.3,
    points: "457.9943,-286.32 461.0775,-287.9764 461.9021,-282.7435 ",
    id: "polygon4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "edge4",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title5"
  }, "00:0c:29:60:4d:60-&gt;00:0c:29:43:d6:e9"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0000fe",
    strokeWidth: 1.2,
    d: "m 241.3232,-419.3126 c 20.6139,-0.4318 43.3144,-0.4669 64.2679,-0.1054",
    id: "path5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0000fe",
    stroke: "#0000fe",
    strokeWidth: 1.2,
    points: "305.5627,-417.6684 305.6289,-421.1677 310.5949,-419.3235 ",
    id: "polygon5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "edge5",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title6"
  }, "00:0c:29:60:4d:60-&gt;00:0c:29:78:c3:cd"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 4.7,
    d: "m 206.7761,-363.5663 c 40.685,65.6648 107.6314,181.5299 145.2877,251.3775",
    id: "path6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ff0000",
    stroke: "#ff0000",
    strokeWidth: 4.7,
    points: "350.3223,-111.0857 353.9444,-113.0332 354.5012,-107.6557 ",
    id: "polygon6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "edge6",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title7"
  }, "00:0c:29:60:4d:60-&gt;00:0c:29:7d:72:26"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0100fd",
    strokeWidth: 1.9,
    d: "m 177.4267,-363.7621 c 2.5686,68.2964 2.5775,191.2219 0.0267,259.8961",
    id: "path7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0100fd",
    stroke: "#0100fd",
    strokeWidth: 1.9,
    points: "175.6947,-103.6754 179.1921,-103.5392 177.2488,-98.6111 ",
    id: "polygon7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "edge7",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title8"
  }, "00:0c:29:60:4d:60-&gt;00:0c:29:81:77:9b"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0400fa",
    strokeWidth: 2.4,
    d: "m 151.1137,-363.7062 c -12.6686,23.7103 -28.9773,52.1872 -43.7504,76.4666",
    id: "path8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0400fa",
    stroke: "#0400fa",
    strokeWidth: 2.4,
    points: "105.738,-287.9361 108.7245,-286.111 104.624,-282.7571 ",
    id: "polygon8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "edge8",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title9"
  }, "00:0c:29:60:4d:60-&gt;00:0c:29:a0:9b:6b"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0300fb",
    strokeWidth: 2.3,
    d: "m 241.3468,-379.7377 c 49.2935,26.8781 115.674,65.0797 166.4664,95.7397",
    id: "path9"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0300fb",
    stroke: "#0300fb",
    strokeWidth: 2.3,
    points: "407.1845,-282.3331 408.9958,-285.328 412.3686,-281.2431 ",
    id: "polygon9"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "edge9",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title10"
  }, "00:0c:29:78:c3:cd-&gt;00:0c:29:60:4d:60"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0100fd",
    strokeWidth: 1.7,
    d: "M 343.0673,-107.5492 C 301.3341,-175.2306 234.5415,-291.0238 198.1218,-358.9173",
    id: "path10"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0100fd",
    stroke: "#0100fd",
    strokeWidth: 1.7,
    points: "199.4538,-360.1375 196.3673,-358.4871 195.5528,-363.7215 ",
    id: "polygon10"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "edge10",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title11"
  }, "00:0c:29:78:c3:cd-&gt;00:0c:29:7d:72:26"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 5.2,
    d: "m 309.6745,-47.573 c -18.9964,0.3791 -39.6735,0.4245 -59.0723,0.1362",
    id: "path11"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ff0000",
    stroke: "#ff0000",
    strokeWidth: 5.2,
    points: "250.2042,-49.7187 250.1287,-45.1693 245.1671,-47.527 ",
    id: "polygon11"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "edge11",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title12"
  }, "00:0c:29:78:c3:cd-&gt;00:0c:29:81:77:9b"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 5.2,
    d: "m 309.545,-88.022 c -49.8097,-27.2015 -116.4762,-65.603 -167.0005,-96.1527",
    id: "path12"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ff0000",
    stroke: "#ff0000",
    strokeWidth: 5.2,
    points: "143.4702,-186.2738 141.1126,-182.3823 138.0149,-186.9188 ",
    id: "polygon12"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "edge14",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title13"
  }, "00:0c:29:7d:72:26-&gt;00:0c:29:60:4d:60"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0000fe",
    strokeWidth: 0.1,
    d: "m 167.9661,-98.7311 c -2.6864,-65.9729 -2.803,-189.1925 -0.3497,-260.133",
    id: "path13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0000fe",
    stroke: "#0000fe",
    strokeWidth: 0.1,
    points: "169.3658,-358.8201 165.8681,-358.9464 167.7975,-363.88 ",
    id: "polygon13"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "edge12",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title14"
  }, "00:0c:29:7d:72:26-&gt;00:0c:29:78:c3:cd"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0000fe",
    strokeWidth: 0.5,
    d: "m 245.3764,-60.4768 c 19.0807,-0.3475 39.6969,-0.3635 58.9187,-0.0479",
    id: "path14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0000fe",
    stroke: "#0000fe",
    strokeWidth: 0.5,
    points: "304.6463,-58.7682 304.7099,-62.2676 309.6773,-60.4269 ",
    id: "polygon14"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "edge13",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title15"
  }, "00:0c:29:7d:72:26-&gt;00:0c:29:81:77:9b"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 5.2,
    d: "m 139.8852,-98.6 c -15.2393,-24.5758 -32.9854,-55.243 -46.9614,-81.1291",
    id: "path15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ff0000",
    stroke: "#ff0000",
    strokeWidth: 5.2,
    points: "94.9077,-180.8435 90.8994,-178.6903 90.5373,-184.1716 ",
    id: "polygon15"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "edge16",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title16"
  }, "00:0c:29:81:77:9b-&gt;00:0c:29:43:d6:e9"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1500e9",
    strokeWidth: 3.2,
    d: "m 138.1914,-280.1034 c 49.8472,-30.2524 116.9916,-69.0065 167.8585,-96.8779",
    id: "path16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1500e9",
    stroke: "#1500e9",
    strokeWidth: 3.2,
    points: "307.0626,-375.5404 305.3836,-378.6114 310.6102,-379.4746 ",
    id: "polygon16"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "edge15",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title17"
  }, "00:0c:29:81:77:9b-&gt;00:0c:29:60:4d:60"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0100fd",
    strokeWidth: 1.7,
    d: "m 90.4962,-282.6665 c 12.6686,-23.7103 28.9772,-52.1872 43.7503,-76.4665",
    id: "path17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0100fd",
    stroke: "#0100fd",
    strokeWidth: 1.7,
    points: "135.8718,-358.4366 132.8853,-360.2617 136.9859,-363.6156 ",
    id: "polygon17"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "edge17",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title18"
  }, "00:0c:29:81:77:9b-&gt;00:0c:29:78:c3:cd"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 6.7,
    d: "m 138.1228,-200.0697 c 49.577,27.0432 116.2902,65.4498 167.0764,96.1306",
    id: "path18"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ff0000",
    stroke: "#ff0000",
    strokeWidth: 6.7,
    points: "303.9578,-101.2641 306.9934,-106.2795 309.7531,-101.1828 ",
    id: "polygon18"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "edge18",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title19"
  }, "00:0c:29:81:77:9b-&gt;00:0c:29:7d:72:26"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0300fb",
    strokeWidth: 2.2,
    d: "m 104.6171,-184.1691 c 15.4793,25.2158 33.0586,55.8073 46.5209,81.0057",
    id: "path19"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0300fb",
    stroke: "#0300fb",
    strokeWidth: 2.2,
    points: "149.7115,-102.1184 152.8025,-103.7602 153.6024,-98.5235 ",
    id: "polygon19"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "edge20",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title20"
  }, "00:0c:29:a0:9b:6b-&gt;00:0c:29:43:d6:e9"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0000fe",
    strokeWidth: 0.1,
    d: "m 447.8223,-282.746 c -15.4792,-25.2158 -33.0586,-55.8073 -46.5209,-81.0057",
    id: "path20"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0000fe",
    stroke: "#0000fe",
    strokeWidth: 0.1,
    points: "402.728,-364.7967 399.637,-363.1549 398.8371,-368.3916 ",
    id: "polygon20"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "edge19",
    className: "edge"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title21"
  }, "00:0c:29:a0:9b:6b-&gt;00:0c:29:60:4d:60"), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0100fd",
    strokeWidth: 1.7,
    d: "m 412.3769,-267.9045 c -49.8444,-27.2411 -116.281,-65.5213 -166.5865,-95.9479",
    id: "path21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0100fd",
    stroke: "#0100fd",
    strokeWidth: 1.7,
    points: "246.4636,-365.4907 244.6497,-362.4974 241.2805,-366.5854 ",
    id: "polygon21"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "node1",
    className: "node"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title22"
  }, "00:0c:29:43:d6:e9"), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a2cd5a",
    stroke: "#a2cd5a",
    points: "310.8296,-368.4151 310.8296,-457.4151 448.8296,-457.4151 448.8296,-368.4151 ",
    id: "polygon22"
  }), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 346.32959,
    y: -408.51511,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text22"
  }, "00:0c:29:43:d6:e9 "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 349.32959,
    y: -399.51511,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text23"
  }, "Running MacOS "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 359.32959,
    y: -390.51511,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text24"
  }, "10.1.2.233 "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 325.82959,
    y: -381.51511,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text25"
  }, "FE80::20C:29FF:FE43:D6E9 "))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "node2",
    className: "node"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title25"
  }, "00:0c:29:60:4d:60"), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a2cd5a",
    stroke: "#a2cd5a",
    points: "104.1099,-363.9151 104.1099,-461.9151 241.1099,-461.9151 241.1099,-363.9151 ",
    id: "polygon25"
  }), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 139.60989,
    y: -413.51511,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text26"
  }, "00:0c:29:60:4d:60 "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 146.10989,
    y: -404.51511,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text27"
  }, "Running Linux "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 152.60989,
    y: -395.51511,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text28"
  }, "10.1.2.210 "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 119.6099,
    y: -386.51511,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text29"
  }, "FE80::20C:29FF:FE60:4D60 "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 156.10989,
    y: -377.51511,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text30"
  }, "SHARES"))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "node3",
    className: "node"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title30"
  }, "00:0c:29:78:c3:cd"), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a2cd5a",
    stroke: "#a2cd5a",
    points: "309.8296,-0.5 309.8296,-107.5 449.8296,-107.5 449.8296,-0.5 ",
    id: "polygon30"
  }), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 346.82959,
    y: -58.599998,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text31"
  }, "00:0c:29:78:c3:cd "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 352.82959,
    y: -49.599998,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text32"
  }, "Running Linux "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 361.32959,
    y: -40.599998,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text33"
  }, "10.1.2.17 "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 324.82959,
    y: -31.6,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text34"
  }, "FE80::20C:29FF:FE78:C3CD "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 357.82959,
    y: -22.6,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text35"
  }, "ccg-ol8-test "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 378.32959,
    y: -13.6,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text36"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "node4",
    className: "node"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title36"
  }, "00:0c:29:7d:72:26"), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a2cd5a",
    stroke: "#a2cd5a",
    points: "100.1099,-9.5 100.1099,-98.5 245.1099,-98.5 245.1099,-9.5 ",
    id: "polygon36"
  }), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 139.60989,
    y: -49.599998,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text37"
  }, "00:0c:29:7d:72:26 "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 152.60989,
    y: -40.599998,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text38"
  }, "10.1.2.192 "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 115.6099,
    y: -31.6,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text39"
  }, "FE80::A55F:37EA:CCAD:93E5 "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 133.60989,
    y: -22.6,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text40"
  }, "DESKTOP-40MA2B7 "))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "node5",
    className: "node"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title40"
  }, "00:0c:29:81:77:9b"), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a2cd5a",
    stroke: "#a2cd5a",
    points: "0,-184.4576 0,-282.4576 138,-282.4576 138,-184.4576 ",
    id: "polygon40"
  }), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 35.5,
    y: -234.0576,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text41"
  }, "00:0c:29:81:77:9b "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 42,
    y: -225.0576,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text42"
  }, "Running Linux "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 48.5,
    y: -216.0576,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text43"
  }, "10.1.2.189 "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 15,
    y: -207.0576,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text44"
  }, "FE80::57C8:DA8:B0FA:D744 "), /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 60,
    y: -198.0576,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text45"
  }, "utility"))), /*#__PURE__*/React.createElement("g", {
    id: "node6",
    className: "node"
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", {
    id: "title45"
  }, "00:0c:29:a0:9b:6b")), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#a2cd5a",
    stroke: "#a2cd5a",
    points: "412.4395,-184.4576 412.4395,-282.4576 554.4395,-282.4576 554.4395,-184.4576 ",
    id: "polygon45"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 449.93951,
    y: -234.0576,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text46"
  }, "00:0c:29:a0:9b:6b ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 449.93951,
    y: -225.0576,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text47"
  }, "Running Windows ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 462.93951,
    y: -216.0576,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text48"
  }, "10.1.2.229 ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 427.43951,
    y: -207.0576,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text49"
  }, "FE80::C74C:54D0:36D8:28B8 ")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    textAnchor: "start",
    x: 444.93951,
    y: -198.0576,
    fontFamily: "Verdana",
    fontSize: "8px",
    fill: "#000000",
    id: "text50"
  }, "WIN-GKUNT6PGI13 ")), /*#__PURE__*/React.createElement("image", {
    width: 27.972088,
    height: 27.296005,
    preserveAspectRatio: "none",
    style: {
      imageRendering: "optimizeQuality"
    },
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAAZiS0dEAAAA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\nT16VPP9vUhKwxsA6g3cAAAAASUVORK5CYII=\n",
    id: "image1-2",
    x: 471.71817,
    y: -273.16083
  }))), /*#__PURE__*/React.createElement("image", {
    width: 24.021446,
    height: 24.021446,
    preserveAspectRatio: "none",
    style: {
      imageRendering: "optimizeQuality"
    },
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAKT2lDQ1BQaG90b3Nob3AgSUNDIHBy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\nHqlvxyF1KZPveP0XbuDDveg1ex0AAAAASUVORK5CYII=\n",
    id: "image1",
    x: 371.6517,
    y: 23.102358
  }), /*#__PURE__*/React.createElement("image", {
    width: 27.972088,
    height: 26.619921,
    preserveAspectRatio: "none",
    style: {
      imageRendering: "optimizeQuality"
    },
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A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\n12+WUPZSzwLt/A+Nzg6eAH0W7QAAAABJRU5ErkJggg==\n",
    id: "image1-6",
    x: 164.71936,
    y: 14.767984
  }), /*#__PURE__*/React.createElement("image", {
    width: 27.972088,
    height: 26.619921,
    preserveAspectRatio: "none",
    style: {
      imageRendering: "optimizeQuality"
    },
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A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\n12+WUPZSzwLt/A+Nzg6eAH0W7QAAAABJRU5ErkJggg==\n",
    id: "image1-6-5",
    x: 369.59698,
    y: 369.63531
  }), /*#__PURE__*/React.createElement("image", {
    width: 27.972088,
    height: 26.619921,
    preserveAspectRatio: "none",
    style: {
      imageRendering: "optimizeQuality"
    },
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A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\n12+WUPZSzwLt/A+Nzg6eAH0W7QAAAABJRU5ErkJggg==\n",
    id: "image1-6-5-2",
    x: 60.029739,
    y: 194.5968
  }), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 24.021446,
    height: 24.021446,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAilJREFU\nWIXVltG5oyAQRv+73zZgC1DCtEBKMCVgCbQQS4AWLCGWsJQQWkgJ7sNmvKCC6LoPO0/mk3gOwwwA\n/C9hjJmMMdPV3/1ZAwYArTXGcQQRVUl4779qxmUHxeBljOMI5xz4PRHFYABA13W7jM2XJfC/ENkU\n4HQDgFLqSpEVL1sDDK4RUUpBKbUpMgxDUT4rIKUEEcEYAyI6LDIMA4ZhQNu2yUSqBQDAe437/X5I\npO/7+ZnhpSi3IRE0/YJzfleEwbz+IYRd+L7AJ7QmANsiZ8GHBJz/PNAfEe89nHOw1qJpGgghZrAQ\nAsB39V8isAoiCJECGHx5BlzdRIoZKGVjV0BTnUQuA7xcyOyEP4pwTYcyEEKAECLJQgleFHi9XoDv\noMl9uqAcMZhjDw5klkBKibZt8Xg8AAB930ETALJwlSkZx5G7g4/vTZFZgE9BIQS01gghFEVQ8IiL\nTikFIQScc5siSQaUUvDez6ksiZTAfCDxshARrLUAgK7rEpFEgP+wrOScSA7M2zPD4zHW2viOsF0D\nR0Te73cVOL4jxLESkF5iaqekpUoiZ8FZgald3zm3RIgoabuj4E0BKSWstdmzPhbhYm2a5hSYY9mb\n8/SXIlw4xphk2/XeI4RQBY52xpld2qWmWISht9ttJdL3fVFgAU64pcPoC/juWxZ5Pp+JCPd3Bbi8\nE54V2Tr/a8BHBIoiZ8FXxARgstZOWuuJfx/9yN9aLoGHv/cb61WQjxnwck8AAAAASUVORK5CYII=\n",
    id: "image1-5",
    x: 168.35483,
    y: 381.92993
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.fa502c6299f724660329d8bf9bb7ebcb.svg";
export { ForwardRef as ReactComponent };